module.exports = __webpack_public_path__ + "img/img_applet.75a0ce33.jpg";